import axios from "@/plugins/Axios";

const model = "ambitos";

function all() {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}`);
}

export { all };
